import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("p", { class: "text-sm text-[#52526f] mt-3" }, "Toque para ampliar a evidência", -1)
const _hoisted_2 = { class: "absolute top-2 right-2 z-[3] flex flex-col gap-2" }
const _hoisted_3 = ["data-testid"]

import { ref, watch } from 'vue'
import { mdiAccountEye, mdiRotateRight } from '@mdi/js'
import ImageFullscreenOverlay from './ImageFullscreenOverlay.vue'
import ProtectedImage from './ProtectedImage.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'BiometryEvidencePanel',
  props: {
    biometryId: {},
    testidPrefix: { default: '' },
    maxHeightClass: { default: 'max-h-[500px]' }
  },
  setup(__props: any) {

const props = __props;



const rotation = ref(0)
const isImageFullscreen = ref(false)

watch(
  () => props.biometryId,
  () => {
    rotation.value = 0
    isImageFullscreen.value = false
  }
)

function testid(name: string): string {
  return props.testidPrefix ? `${props.testidPrefix}-${name}` : name
}

function handleRotate() {
  rotation.value = (rotation.value + 90) % 360
}

function handleOpenImage() {
  if (props.biometryId) {
    isImageFullscreen.value = true
  }
}

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass([
      'bg-[#f0f0f4] rounded-lg flex flex-col items-center justify-center min-h-[370px] relative overflow-hidden',
      _ctx.maxHeightClass
    ])
    }, [
      (_ctx.biometryId)
        ? (_openBlock(), _createBlock(ProtectedImage, {
            key: 0,
            "biometry-id": _ctx.biometryId,
            rotation: rotation.value,
            "img-class": "w-full h-full object-contain rounded p-4 transition-transform",
            "data-testid": testid('evidence-image'),
            onClick: handleOpenImage
          }, null, 8, ["biometry-id", "rotation", "data-testid"]))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createVNode(_component_v_icon, {
              size: "64",
              color: "#52526f"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(mdiAccountEye)), 1)
              ]),
              _: 1
            }),
            _hoisted_1
          ], 64)),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("button", {
          "data-testid": testid('rotate-evidence-button'),
          class: "w-9 h-9 flex items-center justify-center rounded-lg bg-white shadow hover:bg-gray-100 transition-colors",
          onClick: handleRotate
        }, [
          _createVNode(_component_v_icon, {
            size: "20",
            color: "#52526f"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(mdiRotateRight)), 1)
            ]),
            _: 1
          })
        ], 8, _hoisted_3)
      ])
    ], 2),
    (isImageFullscreen.value && _ctx.biometryId)
      ? (_openBlock(), _createBlock(ImageFullscreenOverlay, {
          key: 0,
          modelValue: isImageFullscreen.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((isImageFullscreen).value = $event)),
          rotation: rotation.value,
          "onUpdate:rotation": _cache[1] || (_cache[1] = ($event: any) => ((rotation).value = $event)),
          "biometry-id": _ctx.biometryId
        }, null, 8, ["modelValue", "rotation", "biometry-id"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})